// Copyright (c) 2017 TrainHeroic LLC
// Actions for Library, lists of calendards/programs/etc.
import DESIGNER_ACTIONS from '../designer/actions';

const LIBRARY_ACTIONS = {
    ATHLETES_LOAD: 'athletes-load',
    INVITED_ATHLETES_LOAD: 'invited-athletes-load',
    CALENDAR_PROGRAMS_LOAD: 'library-calendar-programs-load',
    CALENDAR_PROGRAMS_ADD: 'library-calendar-programs-add',
    CALENDAR_PROGRAMS_SUBSCRIBE: 'library-calendar-programs-subscribe',
    CALENDAR_PROGRAMS_UNSUBSCRIBE: 'library-calendar-programs-unsubscribe',
    EXERCISES_LOAD: 'library-exercise-load',
    EXERCISES_TH_CLEAR: 'library-exercise-th-clear',
    EXERCISE_TAGS_LOAD: 'library-exercise-tags-load',
    FIXED_PROGRAMS_LOAD: 'library-programs-load',
    FIXED_PROGRAMS_ADD: 'library-programs-add',
    LEADERBOARDTYPES_LOAD: 'library-leaderboard-types-load',
    LIBRARY_SESSIONS_LOAD: 'library-sessions-load',
    LIBRARY_SESSION_ADD: 'library-session-add',
    LIBRARY_SUBSCRIPTION_ADD: 'library-subscription-add',
    LIBRARY_SUBSCRIPTION_REMOVE: 'library-subscription-remove',
    PARAMTYPES_LOAD: 'library-param-types-load',
    SCHEMES_LOAD: 'library-schemes-load',
    SCHEMES_TH_CLEAR: 'library-schemes-th-clear',
    SPORTS_LOAD: 'library-sports-load',
    UI_RELOAD_DRAWER: 'library-reload-drawer',
    CALENDAR_PROGRAM_CLEAR: 'library-calendar-program-clear',
    LOAD_SUBSCRIPTIONS: 'library-load-subscriptions',
    ORGS_LOAD: 'library-orgs-load',
    ORGS_HEALTH_LOAD: 'library-orgs-health-load',
    FILTER_EXERCISES: 'filter-exercises-settings',
    TEAMS_LOAD: 'teams-load'
};

// merging these because we share the reducer between the calendar and designer
const actions = Object.assign({}, DESIGNER_ACTIONS, LIBRARY_ACTIONS);
export default actions;
